<div class="footer-section d-none d-sm-block">
    <div class="container">
        <div class="row row-cols-6">
            <div class="col ">
                <div class="mb-4 f-bold small-header">CAT</div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">Our Courses</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.cat?.courses">
                            <a href="{{item.link}}" (click)="gotoProduct(item.linktext)">{{item.name}}</a>
                        </li>
                    </ul>
                </div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">Practice</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.cat?.practice">
                            <a href="{{item.link}}" (click)="gotoProduct(item.linktext)">{{item.name}}</a>
                        </li>
                    </ul>
                </div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">Important Links</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.cat?.importantLinks">
                            <a href="{{item.link}}" (click)="gotoProduct(item.linktext)">{{item.name}}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col ">
                <div class="mb-4 f-bold small-header">Other MBA Exams</div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">Our Courses</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.mba?.courses">
                            <a href="{{item.link}}" (click)="gotoProduct(item.linktext)">{{item.name}}</a>
                        </li>
                    </ul>
                </div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">Practice</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.mba?.practice">
                            <a href="{{item.link}}" (click)="gotoProduct(item.linktext)">{{item.name}}</a>
                        </li>

                    </ul>
                </div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">Important Links</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.mba?.importantLinks">
                            <a href="{{item.link}}">{{item.name}}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col ">
                <div class="mb-4 f-bold small-header">IPMAT</div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1">Our Courses</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.ipmat?.courses">
                            <a href="{{item.link}}" (click)="gotoProduct(item.linktext)">{{item.name}}</a>
                        </li>
                    </ul>
                </div>
                <div class="footer-item-contents mb-4 gap-3">
                    <div class="mb-1 footer-item-head">Practice</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.ipmat?.practice">
                            <a href="{{item.link}}">{{item.name}}</a>
                        </li>

                    </ul>
                </div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">Important Links</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.ipmat?.importantLinks">
                            <a href="{{item.link}}">{{item.name}}</a>
                        </li>

                    </ul>
                </div>
            </div>
            <div class="col ">
                <div class="mb-4 f-bold small-header">CUET</div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">Our Courses</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.cuet?.courses">
                            <a href="{{item.link}}" (click)="gotoProduct(item.linktext)">{{item.name}}</a>
                        </li>
                    </ul>
                </div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">Practice</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.cuet?.practice">
                            <a href="{{item.link}}">{{item.name}}</a>
                        </li>

                    </ul>
                </div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">Important Links</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.cuet?.importantLinks">
                            <a href="{{item.link}}">{{item.name}}</a>
                        </li>

                    </ul>
                </div>
            </div>
            <div class="col ">
                <div class="mb-4 f-bold small-header">CLAT</div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">Our Courses</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.clat?.courses">
                            <a href="{{item.link}}" (click)="gotoProduct(item.linktext)">{{item.name}}</a>
                        </li>

                    </ul>
                </div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">Practice</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.clat?.practice">
                            <a href="{{item.link}}">{{item.name}}</a>
                        </li>

                    </ul>
                </div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">Important Links</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.clat?.importantLinks">
                            <a href="{{item.link}}">{{item.name}}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col ">
                <div class="mb-4 f-bold small-header">IIT JEE</div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">Our Courses</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.iit?.courses">
                            <a href="{{item.link}}" (click)="gotoProduct(item.linktext)">{{item.name}}</a>
                        </li>

                    </ul>
                </div>
               
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">Important Links</div>
                    <ul class="list-unstyled">
                        <li class="mb-2" *ngFor="let item of menuItemsList?.iit?.importantLinks">
                            <a href="{{item.link}}">{{item.name}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <hr>
        <div class="row text-left">
            <div class="col-md-6">
                <div class="mb-4 f-bold small-header">PAST PAPERS</div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">CAT</div>
                    <ul class="list-unstyled">
                        <li class="mb-2">
                            <a href="/test/cat-previous-papers"> <span>CAT Past Year Papers Year: 2000 - 2024</span> |
                                <span>QUANT Topic wise Questions</span> | <span>LRDI Topic wise Questions</span> |
                                <span>VARC Topic wise Questions</span></a>
                        </li>
                    </ul>
                </div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">OMET</div>
                    <ul class="list-unstyled">
                        <li class="mb-2">
                            <div> <span [routerLink]="'/test/iift-previous-papers'">IIFT Year: 2015 - 2021</span> | <span
                                    [routerLink]="'/test/cmat-previous-papers'">CMAT Year: 2018 - 2021</span> |
                                <span [routerLink]="'/test/xat-previous-papers'">XAT Year: 2016 - 2022</span> | <span
                                    [routerLink]="'/test/nmat-previous-papers'">NMAT 5 Past Year Papers</span> |
                                <span [routerLink]="'/test/snap-previous-papers'">SNAP Year: 2015 - 2021</span> | <span
                                    [routerLink]="'/test/tiss-previous-papers'">TISS Year: 2017 - 2022</span> </div>
                        </li>
                    </ul>
                </div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">IPMAT</div>
                    <ul class="list-unstyled">
                        <li class="mb-2">
                            <a href="/test/ipmat-previous-papers"> <span>IPMAT Indore Year: 2019 - 2024</span> |
                                <span>IPMAT Rohtak Year: 2019 - 2023</span> |
                                <span>JIPMAT Previous Year Papers</span> </a>
                        </li>
                    </ul>
                </div>
                <div class="d-flex justify-content-between">
                    <div class="footer-item-contents mb-4">
                        <div class="mb-1 footer-item-head">CLAT</div>
                        <ul class="list-unstyled">
                            <li class="mb-2">
                                <a href="/test/clat-previous-papers"> CLAT Year: 2020 - 2024</a>
                            </li>
                        </ul>
                    </div>
                    <div class="footer-item-contents mb-4">
                        <div class="mb-1">CUET</div>
                        <ul class="list-unstyled">
                            <li class="mb-2">
                                <a href="/test/cuet-previous-papers"> CUET UG Past Papers Year: 2023 - 2024</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="mb-4 f-bold small-header">Mocks</div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">CAT</div>
                    <ul class="list-unstyled">
                        <li class="mb-2">
                            <div><span [routerLink]="'/cat-mock-test'">iCAT Full Mocks 35 Full & 45 Sectional</span> |
                                <span [routerLink]="'/cat-mock-test'">MBA Mocks CAT + All Non CAT Mocks</span> |
                                <span [routerLink]="'/cat-mock-test'">iCAT Full Mocks + IIM ABC Batch</span> | <span
                                    [routerLink]="'/details/maha-mba-2025-course'">Maha MBA 2025 Full Course</span> </div>
                        </li>
                    </ul>
                </div>
                <div class="footer-item-contents mb-4">
                    <div class="mb-1 footer-item-head">OMET</div>
                    <ul class="list-unstyled">
                        <li class="mb-2">
                            <div><span [routerLink]="'/details/nmat-snap-mock-series-2024'">NMAT + SNAP 20 Full
                                    Mocks</span> | <span [routerLink]="'/details/nmat-mock-series'">NMAT 10 Full
                                    Mocks</span> |
                                <span [routerLink]="'/details/snap-mock-series'">SNAP 10 Full Mocks</span>
                                | <span [routerLink]="'/mba'">XAT 7 Full Mocks</span> | <span [routerLink]="'/mba'">IIFT
                                    5 Full Mocks</span> |
                                <span [routerLink]="'/mba'">MICAT 5 Full Mocks</span> |
                                <span [routerLink]="'/cmat-mock-test'">CMAT 7 Full Mocks</span> | <span
                                    [routerLink]="'/cuet-pg-mock-test'">CUET PG 7 Full Mocks</span> |
                                <span [routerLink]="'/mahcet-mock-test'">MHCET 7 Full Mocks</span> |
                                <span [routerLink]="'/nmat-mock-test'">PGDBA 5 Full Mocks</span> </div>
                        </li>
                    </ul>
                </div>

                <div class="d-flex justify-content-between">
                    <div class="footer-item-contents mb-4">
                        <div class="mb-1 footer-item-head">IPMAT</div>
                        <ul class="list-unstyled">
                            <li class="mb-2">
                                <a href="/ipmat-mock-test"> IPMAT 2025 Test Series</a>
                            </li>
                        </ul>
                    </div>
                    <div class="footer-item-contents mb-4">
                        <div class="mb-1 footer-item-head">CLAT</div>
                        <ul class="list-unstyled">
                            <li class="mb-2">
                                <a href="/clat-mock-test"> CLAT UG 2025 Mock Test Series</a>
                            </li>
                        </ul>
                    </div>
                    <div class="footer-item-contents mb-4">
                        <div class="mb-1 footer-item-head">CUET</div>
                        <ul class="list-unstyled">
                            <li class="mb-2">
                                <a href="/cuet-mock-test"> CUET PYQ's CUET UG 2025 Mock Test Series </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-md-7">
                <div class="d-flex">
                    <div class="w-30 ">
                        <div class="mb-4 f-bold small-header">Know Us</div>
                        <div class="footer-item-contents mb-4">
                            <ul class="list-unstyled">
                                <li class="mb-2">
                                    <a href="/about-us">iQuanta Team</a>
                                </li>
                                <li class="mb-2">
                                    <a href="/iquanta-toppers-meet">iQuanta Topper's Meet</a>
                                </li>
                                <li class="mb-2">
                                    <a href="/iquanta-Initiative">iQuanta Village Adoption</a>
                                </li>
                                <li class="mb-2">
                                    <a href="/case-study">Case Studies on iQuanta</a>
                                </li>
                                <li class="mb-2">
                                    <a href="/confession">iQuanta Confession Page</a>
                                </li>
                                <li class="mb-2">
                                    <a href="/terms-and-conditions">Terms and Conditions</a>
                                </li>
                                <li class="mb-2">
                                    <a href="/privacy-policy">Privacy Policy</a>
                                </li>
                                <li class="mb-2">
                                    <a href="/refund-policy">Refund Policy</a>
                                </li>
                                <li class="mb-2">
                                    <a href="/site-map.xml">Site Map</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div class="mb-4 f-bold small-header">Offline Centers</div>
                        <div class="footer-item-contents mb-4">
                            <ul class="list-unstyled">
                                <li class="mb-2">
                                    <div><span [routerLink]="'/offline-center/agra'">Agra, Uttar Pradesh</span> | <span
                                            [routerLink]="'/offline-center/bhopal'">Bhopal, Madhya Pradesh </span>|
                                        <span [routerLink]="'/offline-center/bhubaneswar'">Bhubaneswar, Odisha</span> |
                                    </div>
                                </li>
                                <li class="mb-2">
                                    <div><span [routerLink]="'/offline-center/chandigarh'">Chandigarh, Chandigarh</span> |
                                        <span [routerLink]="'/offline-center/goa'">Goa, Goa</span> | <span
                                            [routerLink]="'/offline-center/indore'">Indore, Madhya Pradesh</span></div>
                                </li>
                                <li class="mb-2">
                                    <div><span [routerLink]="'/offline-center/jaipur'">Jaipur, Rajasthan</span> | <span
                                            [routerLink]="'/offline-center/jammu'">Jammu, Jammu & Kashmir</span> | <span
                                            [routerLink]="'/offline-center/jamshedpur'">Jamshedpur, Jharkhand</span> |
                                        <span [routerLink]="'/offline-center/kolkata'">Kolkata,</span></div>
                                </li>
                                <li class="mb-2">
                                    <div><span [routerLink]="'/offline-center/kolkata'">West Bengal</span> | <span
                                            [routerLink]="'/offline-center/nagpur'">Nagpur, Maharastra</span> | <span
                                            [routerLink]="'/offline-center/patna'">Patna, Bihar</span> | <span
                                            [routerLink]="'/offline-center/prayagraj'">Prayagraj, Uttar Pradesh</span>
                                        |</div>
                                </li>
                                <li class="mb-2">
                                    <div><span [routerLink]="'/offline-center/raipur'">Raipur, Chhattisgarh</span> | <span
                                            [routerLink]="'/offline-center/rajkot'">Rajkot, Gujarat</span> | <span
                                            [routerLink]="'/offline-center/ranchi'">Ranchi, Jharkhand</span> | <span
                                            [routerLink]="'/offline-center/srinagar'">Srinagar, Jammu &</span></div>
                                </li>
                                <li class="mb-2">
                                    <div><span [routerLink]="'/offline-center/srinagar'">Kashmir</span> | <span
                                            [routerLink]="'/offline-center/surat'">Surat, Gujarat</span> | <span
                                            [routerLink]="'/offline-center/vadodara'">Vadodara, Gujarat</span></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5">
                <div class="mb-4 f-bold small-header">Blog</div>
                <div class="d-md-flex gap-3 flex-wrap">
                    <div class="blog-inner-card d-flex p-2"
                        (click)="gotoBlog('https://www.iquanta.in/blog/best-cat-mock-test-series/')">
                        <div class="img">
                            <img src="https://media.iquanta.in/ui_images/footer/blog1.webp"
                                alt="Best CAT Mock Test" loading="lazy">
                        </div>
                        <div class="text text ml-2 pl-1">
                            <div class="f-medium footer-item-head">Best CAT Mock Test</div>
                            <p class="mb-0 f-light">Which CAT Mock Test Series to Choose?</p>
                        </div>
                    </div>

                    <div class="blog-inner-card d-flex p-2"
                        (click)="gotoBlog('https://www.iquanta.in/blog/how-to-analyse-cat-mocks/')">
                        <div class="img">
                            <img src="https://media.iquanta.in/ui_images/footer/blog2.webp" alt="iQuanta Blog"
                                loading="lazy">
                        </div>
                        <div class="text text ml-2 pl-1">
                            <div class="f-medium footer-item-head">CAT Mock Analysis</div>
                            <p class="mb-0 f-light">Latest CAT Mock Strategy 2025</p>
                        </div>
                    </div>

                    <div class="blog-inner-card d-flex p-2"
                        (click)="gotoBlog('https://www.iquanta.in/blog/importance-of-mock-tests-for-cat-2025/')">
                        <div class="img">
                            <img src="https://media.iquanta.in/ui_images/footer/blog3.webp" alt="iQuanta Blog"
                                loading="lazy">
                        </div>
                        <div class="text text ml-2 pl-1">
                            <div class="f-medium footer-item-head">Mock Tests</div>
                            <p class="mb-0 f-light">Importance of Mock Tests for CAT 2025</p>
                        </div>
                    </div>

                    <div class="blog-inner-card d-flex p-2"
                        (click)="gotoBlog('https://www.iquanta.in/blog/cat-mock-analysis-within-minutes/')">
                        <div class="img">
                            <img src="https://media.iquanta.in/ui_images/footer/blog4.webp" alt="iQuanta Blog"
                                loading="lazy">
                        </div>
                        <div class="text text ml-2 pl-1">
                            <div class="f-medium footer-item-head" >Analysis Within Minutes</div>
                            <p class="mb-0 f-light">Wasting Your Time on Mock Analysis? Get the CAT Mock Analysis Within Minutes</p>
                        </div>
                    </div>

                </div>
                <div class="copy-right mt-4">
                    <p>© 2025 iQuanta. All Right Reserved</p>
                </div>
            </div>
          
        </div>
    </div>
</div>

<div *ngIf="!hideBarFlag">
    <div class="d-block d-sm-none">
        <div class="footer-sticky-menu position-fixed header">
            <ul class="footer-icon-menu m-0 p-0 d-flex justify-content-between list-unstyled">
                <li>
                    <div class="foot-nav" [routerLink]="'/'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M14.0725 1.25326C12.5999 -0.0349399 10.4014 -0.0349418 8.92877 1.25326L1.99293 7.32046C0.918859 8.26002 0.302734 9.61759 0.302734 11.0446V19.8331C0.302734 21.9905 2.05162 23.7394 4.20898 23.7394H18.7923C20.9497 23.7394 22.6986 21.9905 22.6986 19.8331V11.0446C22.6986 9.61759 22.0824 8.26002 21.0084 7.32047L14.0725 1.25326ZM7.50238 14.4423C7.31712 14.0526 6.85105 13.8869 6.46137 14.0721C6.07169 14.2574 5.90597 14.7234 6.09123 15.1131C6.57767 16.1363 7.34435 17.0006 8.30225 17.6056C9.26016 18.2106 10.37 18.5314 11.5029 18.531C12.636 18.5306 13.7455 18.2088 14.7029 17.6031C15.6603 16.9974 16.4264 16.1325 16.912 15.1089C17.097 14.7191 16.9309 14.2531 16.5411 14.0682C16.1513 13.8832 15.6853 14.0493 15.5003 14.4392C15.1414 15.1957 14.5752 15.835 13.8675 16.2827C13.1599 16.7304 12.3397 16.9682 11.5023 16.9685C10.6649 16.9688 9.84461 16.7317 9.13661 16.2845C8.4286 15.8374 7.86192 15.1985 7.50238 14.4423Z"
                                fill="#FFF4EF" />
                        </svg>
                        <span>Home</span>
                    </div>
                </li>
                <li>
                    <div class="foot-nav " data-toggle="modal" data-target="#exampleModalLeft">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="25" viewBox="0 0 28 25" fill="none">
                            <path
                                d="M22.7308 20.0192L22.2115 20.5385C21.6346 21.1154 20.8846 21.4038 20.0769 21.4038H18.5769C17.1923 21.4038 15.6923 20.3077 15.6923 18.4038V16.9615C15.6923 15.8077 16.2115 15.1154 16.5 14.7115L22.7308 8.36538C22.9038 8.19231 23.0769 7.78846 23.0769 7.55769V2.76923C23.0769 1.26923 21.8077 0 20.3077 0H5.53846C4.03846 0 2.76923 1.38462 2.76923 2.76923H1.84615C0.807692 2.76923 0 3.63462 0 4.67308C0 5.71154 0.807692 6.51923 1.84615 6.51923H2.76923V10.2692H1.84615C0.807692 10.2692 0 11.0769 0 12.1154C0 13.1538 0.807692 13.9615 1.84615 13.9615H2.76923V17.7115H1.84615C0.807692 17.7115 0 18.5769 0 19.5577C0 20.5962 0.807692 21.4038 1.84615 21.4038H2.76923C2.76923 23.25 4.03846 24.1731 5.53846 24.1731H20.3077C21.8077 24.1731 23.0769 22.9038 23.0769 21.4038V20.1923C23.0769 19.9038 22.9615 19.8462 22.7308 20.0192ZM18 6.98077C18 7.5 17.5962 7.90385 17.0769 7.90385H7.84615C7.32692 7.90385 6.92308 7.5 6.92308 6.98077V6.05769C6.92308 5.53846 7.32692 5.13461 7.84615 5.13461H17.0769C17.5962 5.13461 18 5.53846 18 6.05769V6.98077ZM13.8462 18.1731C13.8462 18.6923 13.4423 19.0962 12.9231 19.0962H7.84615C7.32692 19.0962 6.92308 18.6923 6.92308 18.1731V17.25C6.92308 16.7308 7.32692 16.3269 7.84615 16.3269H12.9231C13.4423 16.3269 13.8462 16.7308 13.8462 17.25V18.1731ZM15.2308 12.5769C15.2308 13.0962 14.8269 13.5 14.3077 13.5H7.84615C7.32692 13.5 6.92308 13.0962 6.92308 12.5769V11.6538C6.92308 11.1346 7.32692 10.7308 7.84615 10.7308H14.3077C14.8269 10.7308 15.2308 11.1346 15.2308 11.6538V12.5769Z"
                                fill="#FFF4EF" />
                            <path
                                d="M27.4038 10.0385L26.8269 9.46154C26.4808 9.11538 25.9038 9.11538 25.5577 9.46154L18.5192 16.7308C18.4615 16.7308 18.4615 16.8462 18.4615 16.8462V18.4038C18.4615 18.5192 18.4615 18.6346 18.5769 18.6346H20.0769C20.1346 18.6346 20.1923 18.5769 20.25 18.5769L27.3462 11.4231C27.8077 11.0192 27.8077 10.4423 27.4038 10.0385Z"
                                fill="#FFF4EF" />
                        </svg>
                        <span>Mocks</span>
                    </div>
    
                </li>
                <li>
                    <div class="foot-nav" data-toggle="modal" data-target="#exampleModalLeft1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M14.3523 5.64717C16.5614 5.64717 18.3523 7.43803 18.3523 9.64717V20C18.3523 22.2091 16.5614 24 14.3523 24H4C1.79086 24 0 22.2091 0 20V9.64716C0 7.43803 1.79086 5.64717 4 5.64717H14.3523ZM20 0C22.2091 0 24 1.79086 24 4V16.2367C24 17.4062 23.0519 18.3542 21.8824 18.3542C20.7129 18.3542 19.7649 17.4062 19.7649 16.2367V8.23528C19.7649 6.02614 17.974 4.23527 15.7649 4.23527H7.76394C6.5944 4.23527 5.6463 3.28718 5.6463 2.11764C5.6463 0.948098 6.5944 0 7.76394 0H20ZM4.23515 12.0001C4.23515 12.3899 4.55118 12.7059 4.94103 12.7059H13.4113C13.8011 12.7059 14.1171 12.3899 14.1171 12.0001C14.1171 11.6102 13.8011 11.2942 13.4113 11.2942H4.94103C4.55118 11.2942 4.23515 11.6102 4.23515 12.0001ZM4.23515 14.8236C4.23515 15.2134 4.55118 15.5295 4.94103 15.5295H10.5879C10.9777 15.5295 11.2937 15.2134 11.2937 14.8236C11.2937 14.4337 10.9777 14.1177 10.5878 14.1177H4.94103C4.55118 14.1177 4.23515 14.4337 4.23515 14.8236ZM4.23515 17.6478C4.23515 18.038 4.5515 18.3544 4.94173 18.3544H13.4106C13.8008 18.3544 14.1171 18.038 14.1171 17.6478C14.1171 17.2576 13.8008 16.9412 13.4106 16.9412H4.94173C4.5515 16.9412 4.23515 17.2576 4.23515 17.6478Z"
                                fill="#FFF4EF" />
                        </svg>
                        <span>Past Papers</span>
                    </div>
                </li>
                <li>
                    <div class="foot-nav" [routerLink]="'/results'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="25" viewBox="0 0 23 25" fill="none">
                            <path
                                d="M17.1682 10.3781C20.1972 9.28574 22.3687 6.3833 22.3687 2.98232L22.3502 2.15137H17.5694V0H4.79941V2.15137H0.0185546L0 2.98232C0 6.3832 2.17158 9.28564 5.20059 10.3781C5.91406 12.1771 7.42695 13.4857 9.29023 14.0625V16.0156C9.20635 17.5457 7.91211 18.8477 6.36055 18.8477V20.6055H4.79805V24.0234H17.5707V20.6055H16.0082V18.8477C14.4566 18.8477 13.1624 17.5457 13.0785 16.0156V14.0625C14.9418 13.4857 16.4547 12.177 17.1682 10.3781ZM17.5707 3.80859H20.5554C20.5495 3.85029 20.5453 3.90791 20.5387 3.94932C20.2437 5.79072 19.1185 7.33613 17.5693 8.24687C17.5732 8.15518 17.5707 3.80859 17.5707 3.80859ZM1.83008 3.94932C1.82344 3.90791 1.81924 3.85029 1.81338 3.80859H4.79805C4.79805 3.80859 4.79551 8.15518 4.79932 8.24687C3.25029 7.33613 2.1251 5.79072 1.83008 3.94932ZM11.1844 7.98604L9.20635 9.30635L9.85078 7.01709L7.98389 5.54395L10.3603 5.44951L11.1845 3.21865L12.0087 5.44951L14.3851 5.54395L12.518 7.01719L13.1624 9.30645L11.1844 7.98604Z"
                                fill="#FFF4EF" />
                        </svg>
                        <span>Result</span>
                    </div>
                </li>
                <li>
                    <div class="foot-nav" data-toggle="modal" data-target="#exampleModalLeft2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="19" viewBox="0 0 24 19" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M0 1.35714C0 0.60762 0.59696 0 1.33333 0H22.6667C23.4031 0 24 0.60762 24 1.35714C24 2.10667 23.4031 2.71429 22.6667 2.71429H1.33333C0.59696 2.71429 0 2.10667 0 1.35714ZM0 9.5C0 8.75045 0.59696 8.14286 1.33333 8.14286H22.6667C23.4031 8.14286 24 8.75045 24 9.5C24 10.2495 23.4031 10.8571 22.6667 10.8571H1.33333C0.59696 10.8571 0 10.2495 0 9.5ZM0 17.6429C0 16.8933 0.59696 16.2857 1.33333 16.2857H22.6667C23.4031 16.2857 24 16.8933 24 17.6429C24 18.3924 23.4031 19 22.6667 19H1.33333C0.59696 19 0 18.3924 0 17.6429Z"
                                fill="#FFF4EF" />
                        </svg>
                        <span>More</span>
                    </div>
                </li>
            </ul>
    
    
        </div>
    </div>
</div>


<div class="modal fade drawer left-align" id="exampleModalLeft" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" >
    <div class="modal-dialog" role="document">
        <div class="modal-content navigation">

            <div class="modal-body menu">
                <div class="d-flex justify-content-between">
                    <div class="current-menu-title">Mocks</div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                </div>
                <ul class="menu-main">
                    <li class="menu-item-has-children">

                        <div class="sub-menu active mega-menu mega-menu-column-4">
                            <div class="list-item">
                                <div class="title">CAT</div>
                                <ul>
                                    <li >
                                        <a href="/cat-mock-test"> iCAT Full Mocks 35 Full & 45 Sectional </a>
                                    </li>
                                    <li >
                                        <a href="/cat-mock-test"> MBA Mocks
                                            CAT + All NON CAT Mocks </a>
                                    </li>
                                    <li >
                                        <a href="/cat-mock-test"> iCAT Full Mocks
                                            + IIM ABC Batch </a>
                                    </li>
                                    <li (click)="gotoProduct('maha-mba-2024-course')"
                                        >
                                        <a href="/details/maha-mba-2024-course"> Maha MBA 2024 Full Course</a>
                                    </li>

                                </ul>
                            </div>
                            <div class="list-item">
                                <div class="title">OMET</div>
                                <ul>
                                    <li 
                                        (click)="gotoProduct('nmat-snap-mock-series')">
                                        <a href="/details/nmat-snap-mock-series-2024">
                                            NMAT + SNAP 20 Full Mocks</a></li>
                                    <li 
                                        (click)="gotoProduct('nmat-mock-series')"><a href="/details/nmat-mock-series">
                                            NMAT 10 Full Mocks</a></li>
                                    <li 
                                        (click)="gotoProduct('snap-mock-series')"><a href="/details/snap-mock-series">
                                            SNAP 10 Full Mocks</a></li>
                                    <li (click)="scrollTo1('233')"><div>
                                            XAT 7 Full Mocks</div></li>
                                    <li (click)="scrollTo1('234')"><div>
                                            IIFT 5 Full Mocks</div></li>
                                    <li (click)="scrollTo1('236')"><div>
                                            MICAT 5 Full Mocks</div></li>
                                    <li ><a href="/cmat-mock-test">
                                            CMAT 7 Full Mocks</a></li>
                                    <li ><a href="/cuet-pg-mock-test">
                                            CUET PG 7 Full Mocks</a></li>
                                    <li ><a href="/mahcet-mock-test">
                                        MHCET 7 Full Mocks</a></li>
                                    <li ><a href="/nmat-mock">
                                        PGDBA 5 Full Mocks</a></li>

                                </ul>

                            </div>
                            <div class="list-item">
                                <div class="title">IPMAT</div>
                                <ul>
                                    <li ><a href="/ipmat-mock-test">
                                            IPMAT 2025 Test Series</a></li>
                                </ul>
                            </div>
                            <div class="list-item">
                                <div class="title">CLAT</div>
                                <ul>
                                    <li ><a href="/clat-mock-test">
                                        CLAT UG 2025 Mock Test Series</a></li>
                                </ul>
                            </div>
                            <div class="list-item">
                                <div class="title">CUET</div>
                                <ul>
                                    <li ><a href="/cuet-mock-test">
                                        CUET PYQ's CUET UG 2024 Mock Test Series</a></li>
                                </ul>
                            </div>

                        </div>
                    </li>



                </ul>
            </div>

        </div>
    </div>
</div>


<div class="modal fade drawer left-align" id="exampleModalLeft1" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" >
    <div class="modal-dialog" role="document">
        <div class="modal-content navigation">

            <div class="modal-body menu">
                <div class="d-flex justify-content-between">
                    <div class="current-menu-title">Past Papers</div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                </div>
                <ul class="menu-main">
                    <li class="menu-item-has-children">

                        <div class="sub-menu active mega-menu mega-menu-column-4">
                            <div class="list-item">
                                <div class="title">CAT</div>
                                <ul>
                                    <li (click)="qa('cat-previous-papers')">
                                        <a href="/test/cat-previous-papers"> CAT Past Year Papers
                                            Year: 2000 - 2024 </a>
                                    </li>
                                    <li (click)="qa('cat-previous-papers')">
                                        <a href="/test/cat-previous-papers"> Quant Topic Wise
                                            Questions</a>
                                    </li>
                                    <li (click)="qa('cat-previous-papers')">
                                        <a href="/test/cat-previous-papers"> LRDI Topic Wise
                                            Questions </a>
                                    </li>
                                    <li (click)="qa('cat-previous-papers')">
                                        <a href="/test/cat-previous-papers">  VARC Topic Wise
                                            Questions</a>
                                    </li>

                                </ul>
                            </div>
                            <div class="list-item">
                                <div class="title">OMET</div>
                                <ul>
                                    <li (click)="qa('iift-previous-papers')"><a href="/test/iift-previous-papers">
                                            IIFT Year: 2015 - 2021</a></li>
                                    <li (click)="qa('cmat-previous-papers')"><a href="/test/cmat-previous-papers">
                                            CMAT Year: 2018 - 2021</a></li>
                                    <li (click)="qa('xat-previous-papers')"><a href="/test/xat-previous-papers">
                                            XAT Year: 2016 - 2024</a></li>
                                    <li (click)="qa('nmat-previous-papers')"><a href="/test/nmat-previous-papers">
                                        NMAT 5 Past Year Papers</a></li>
                                    <li (click)="qa('snap-previous-papers')"><a href="/test/snap-previous-papers">
                                        SNAP Year: 2015 - 2021</a></li>
                                    <li (click)="qa('tiss-previous-papers')"><a href="/test/tiss-previous-papers">
                                        TISS Year: 2017 - 2022</a></li>
                                </ul>

                            </div>
                            <div class="list-item">
                                <div class="title">IPMAT</div>
                                <ul>
                                    <li (click)="qa('ipmat-previous-papers')"><a href="/test/ipmat-previous-papers">
                                        IPMAT Indore Year: 2019 - 2024</a></li>
                                        <li (click)="qa('ipmat-previous-papers')"><a href="/test/ipmat-previous-papers">
                                            IPMAT Rohtak Year: 2019 - 2023</a></li>
                                            <li (click)="qa('ipmat-previous-papers')"><a href="/test/ipmat-previous-papers">
                                                JIPMAT Previous Year Papers</a></li>
                                </ul>
                            </div>
                            <div class="list-item">
                                <div class="title">CLAT</div>
                                <ul>
                                    <li (click)="qa('clat-previous-papers')"><a href="/test/clat-previous-papers">
                                        CLAT Year: 2020 - 2024</a></li>
                                </ul>
                            </div>
                            <div class="list-item">
                                <div class="title">CUET</div>
                                <ul>
                                    <li (click)="qa('cuet-previous-papers')"><a href="/test/cuet-previous-papers">
                                        CUET UG Past Papers Year: 2023 - 2024</a></li>
                                </ul>
                            </div>

                        </div>
                    </li>



                </ul>
            </div>

        </div>
    </div>
</div>

<div class="modal fade drawer left-align" id="exampleModalLeft2" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" >
    <div class="modal-dialog" role="document">
        <div class="modal-content navigation">

            <div class="modal-body menu">
                <div class="d-flex justify-content-between">
                    <div class="current-menu-title">Company</div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                </div>
                <ul class="menu-main">
                    <li class="menu-item-has-children">

                        <div class="sub-menu active mega-menu mega-menu-column-4">
                            <div class="list-item">
                                <div class="title">About</div>
                                <ul>
                                    <li >
                                        <a href="/about-us"> About Company</a>
                                    </li>
                                    <li >
                                        <a href="https://www.iquanta.in/blog/"> Blog</a>
                                    </li>
                                    <li >
                                        <a href="/career"> Careers</a>
                                    </li>
                                    <li >
                                        <a href="/contact">  Contact Us</a>
                                    </li>
                                    <li >
                                        <a href="/results"> Results</a>
                                    </li>
                                    <li >
                                        <a href="/franchise">  Franchises </a>
                                    </li>

                                </ul>
                            </div>
                            <div class="list-item">
                                <div class="title">Terms and Policies</div>
                                <ul>
                                    <li ><a href="/terms-and-conditions">
                                           Terms & Conditions</a></li>
                                    <li ><a href="/privacy-policy">
                                            Privacy Policy</a></li>
                                    <li ><a href="/refund-policy">
                                            Refund Policy</a></li>
                                    <li ><a href="https://www.iquanta.in/site-map.xml" target="_blank">
                                        Sitemap</a></li>
                                </ul>

                            </div>
                            <div class="list-item">
                                <div class="title">Reach out to us</div>
                               <p>Get your questions answered about learning with iQuanta</p>
                               <ul>
                                <li ><a href="tel:8130900243">
                                       Call: 8130900243</a></li>
                                <li ><div >
                                    Ground Floor, 126, Udyog Vihar Phase 4 Rd, Phase III, Udyog Vihar, Sector 19, Gurugram, Haryana 122022</div></li>
                          <li><div class="d-flex">Follow us at: 
                            <div class="d-flex">
                                <div (click)="gotoLink('https://www.facebook.com/IndrajeetiQuanta')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                                        viewBox="0 0 36 54" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M23.8711 13.7221C25.1275 12.5577 27.0724 12.6846 27.2152 12.691L35.3533 12.6878L35.5309 0.945478L34.303 0.644062C33.5163 0.450562 31.1081 0 25.8001 0C16.3486 0 9.99672 6.61517 9.99672 16.457V19.0999H0.478516V31.7908H9.99672V54H22.6877V31.7908H32.7199L34.4649 19.0999H22.6877V17.155C22.6877 15.6099 23.0874 14.4518 23.8711 13.7221Z"
                                            fill="url(#paint0_linear_970_12740)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_970_12740" x1="18.0047" y1="0"
                                                x2="18.0047" y2="54" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#724A39" />
                                                <stop offset="1" stop-color="#AB7E6B" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                                <div (click)="gotoLink('https://www.instagram.com/indralion/')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                                        viewBox="0 0 54 54" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M15.8481 0.331368C11.4528 0.529682 7.6432 1.60427 4.56703 4.66744C1.48013 7.74669 0.418882 11.5714 0.220073 15.9209C0.0964883 18.6357 -0.626168 39.1453 1.46938 44.5239C2.88254 48.1526 5.66579 50.9426 9.32763 52.3602C11.0363 53.0249 12.9868 53.4748 15.8481 53.6061C39.7723 54.6888 48.6407 54.0993 52.3805 44.5239C53.0441 42.8195 53.5008 40.8707 53.6271 38.0165C54.7205 14.0311 53.4498 8.83206 49.2802 4.66744C45.973 1.36843 42.0828 -0.877283 15.8481 0.331368ZM16.0683 48.7822C13.4489 48.6643 12.0277 48.2278 11.0793 47.8607C8.69361 46.9334 6.90166 45.1489 5.98015 42.7771C4.38431 38.6902 4.91359 19.2793 5.05598 16.1384C5.19568 13.0619 5.81897 10.2501 7.98974 8.07934C10.6763 5.39938 14.1474 4.08596 37.7815 5.15259C40.8657 5.29194 43.684 5.91395 45.8601 8.07934C48.5467 10.7593 49.8793 14.257 48.7939 37.8003C48.6757 40.4133 48.2378 41.8311 47.8697 42.7771C45.4383 49.008 39.8448 49.8729 16.0683 48.7822ZM38.0421 12.6619C38.0421 14.4361 39.4848 15.8787 41.266 15.8787C43.0473 15.8787 44.4926 14.4361 44.4926 12.6619C44.4926 10.8878 43.0473 9.44647 41.266 9.44647C39.4848 9.44647 38.0421 10.8878 38.0421 12.6619ZM13.1292 26.9674C13.1292 34.5677 19.3057 40.7297 26.9249 40.7297C34.5441 40.7297 40.7207 34.5677 40.7207 26.9674C40.7207 19.3671 34.5441 13.2091 26.9249 13.2091C19.3057 13.2091 13.1292 19.3671 13.1292 26.9674ZM17.9705 26.9674C17.9705 22.0363 21.9789 18.0356 26.9249 18.0356C31.871 18.0356 35.8794 22.0363 35.8794 26.9674C35.8794 31.9012 31.871 35.9032 26.9249 35.9032C21.9789 35.9032 17.9705 31.9012 17.9705 26.9674Z"
                                            fill="url(#paint0_linear_970_12736)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_970_12736" x1="27" y1="0" x2="27"
                                                y2="54" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#724A39" />
                                                <stop offset="1" stop-color="#AB7E6B" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                                <div (click)="gotoLink('https://www.linkedin.com/in/indralion/')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                                        viewBox="0 0 35 35" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M35.0005 35.001H28.0005V22.7527C28.0005 19.3927 26.5182 17.5181 23.86 17.5181C20.9672 17.5181 19.2505 19.4714 19.2505 22.7527V35.001H12.2505V12.251H19.2505V14.8093C19.2505 14.8093 21.4467 10.9556 26.3957 10.9556C31.3465 10.9556 35.0005 13.9767 35.0005 20.2277V35.001ZM4.27399 8.61255C1.91324 8.61255 0.000488281 6.68416 0.000488281 4.30591C0.000488281 1.92941 1.91324 0.000976562 4.27399 0.000976562C6.63299 0.000976562 8.54573 1.92941 8.54573 4.30591C8.54748 6.68416 6.63299 8.61255 4.27399 8.61255ZM0.000488281 35.001H8.75049V12.251H0.000488281V35.001Z"
                                            fill="url(#paint0_linear_970_12681)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_970_12681" x1="17.5005"
                                                y1="0.000976562" x2="17.5005" y2="35.001"
                                                gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#724A39" />
                                                <stop offset="1" stop-color="#AB7E6B" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                            </div>
                        </div> 
                          
                        </li>
                                </ul>



                            </div>
                           

                        </div>
                    </li>



                </ul>
            </div>

        </div>
    </div>
</div>